<template>
  <div class="vfuSelection w-100 d-flex flex-column">
    <h3 class="mt-5">What Units Are Affected?</h3>
    <v-autocomplete
      v-model="selectedAssets"
      :search-input.sync="assetText"
      :items="filteredAssetOptions"
      dense
      chips
      clearable
      deletable-chips
      multiple
      return-object
      item-text="name"
      item-value="id"
      ref="assetSelect"
    >
      <template v-slot:selection="data">
        <v-chip
          color="primary"
          outlined
        >
          <v-icon class="mr-1 v-icon--left"> mdi-star-circle-outline</v-icon>
          {{ data.item.name }}
          <v-btn
            icon
            small
            class="v-chip__close v-icon--link v-icon--right"
            @click.stop="removeAsset(data.item)"
            ><v-icon>cancel</v-icon></v-btn
          >
        </v-chip>
      </template>
      <template v-slot:[`append-item`]>
        <v-hover
          v-if="assetText && assetText.length"
          v-slot="{ hover }"
        >
          <div
            :class="{ 'grey lighten-4': hover }"
            class="d-flex align-center clickable mx-3 px-3 py-2 rounded-lg"
            @click="createAsset(assetText)"
          >
            <v-icon color="primary">mdi-plus-circle</v-icon>
            <span class="ml-2 primary--text">Create: '{{ assetText }}'</span>
          </div>
        </v-hover>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Trimaster from '@/plugins/servers/trimaster';

export default {
  name: 'VfuSelection',
  components: {},
  async mounted() {
    this.isLoading = true;
    await this.loadAssets();
    this.isLoading = false;
  },
  data() {
    return {
      isLoading: false,
      selectedAssets: [],
      assetOptions: [],
      assetText: '',
      newAssetId: 0,
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    filteredAssetOptions() {
      return this.assetOptions.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
    },
  },
  watch: {
    selectedAssets(newValue) {
      this.$store.dispatch('repairTickets/setSelectedAssets', newValue);
    },
  },
  methods: {
    async loadAssets() {
      let [response, err] = await Trimaster.get('maintenanceTasks/getAssets', this.getUser.apitoken);
      this.assetOptions = response.data;
    },
    removeAsset(item) {
      this.selectedAssets = this.selectedAssets.filter((asset) => asset.id !== item.id);
    },
    createAsset(assetText) {
      const newAssetOption = {
        id: `new-${++this.newAssetId}`,
        facility_id: this.getUser.facility_id,
        name: assetText,
        type: 'asset',
      };
      this.assetOptions.push(newAssetOption);
      this.selectedAssets.push(newAssetOption);
      this.$refs.assetSelect.blur();
      this.assetText = '';
    },
  },
};
</script>

<style lang="scss"></style>
